module.exports = __webpack_public_path__ + "assets/4d156ee0485ab4b40b090a3cd7b995a9.js";